export const InternalLink = {
	Brands: '/znacky-krmiv',
	Ingredients: '/slozeni-krmiv',
	BlogPosts: '/rady-a-tipy',
	Wizard: '/srovnavac',
	Comparator: '/porovnani',
	Login: '/prihlaseni',
	Register: '/registrace',
	Home: '/',
	SearchPage: '/vyhledavani',
	Results: '/granule-pro-psy',
	MyResults: '/granule-pro-meho-psa',
	Contact: '/kontakt',
	PasswordChange: '/nove-heslo',
	Ingredient: '/s/',
	IngredientCategory: '/ks/',
	Product: '/p/',
	Brand: '/z/',
	BlogPost: '/c/',
	ProductLine: '/pr/',
	gdpr: '/gdpr',
	Protected: '/protected/',
}
